import { render, staticRenderFns } from "./AllLessons.vue?vue&type=template&id=8213f718&scoped=true&"
import script from "./AllLessons.vue?vue&type=script&lang=js&"
export * from "./AllLessons.vue?vue&type=script&lang=js&"
import style0 from "./AllLessons.vue?vue&type=style&index=0&id=8213f718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8213f718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VDivider})
